<div class="content">
    <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>
    <h3 mat-dialog-title>Edit Scenario Name</h3>
    <mat-dialog-content>
        <div>
            <form [formGroup]="scenarioForm">
                <div class="row">
                    <mat-form-field class="col-12" appearance="outline" floatLabel="always">
                        <mat-label>Scenario Name</mat-label>
                        <input type="text" matInput formControlName="name">
                    </mat-form-field>
                </div>

                <div class="row">
                    <mat-form-field class="col-12" appearance="outline" floatLabel="always">
                        <mat-label>Scenario Description</mat-label>
                        <textarea type="textarea" matInput placeholder="Add an optional description.  This will be displayed to the client."
                            formControlName="notes"></textarea>
                    </mat-form-field>
                </div>

            </form>
        </div>
    </mat-dialog-content>
    <div mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Back</button>
        <button mat-button class="btn btn-primary" *ngIf="data !== null" [disabled]="scenarioForm.invalid"
            (click)="saveChanges()">Save</button>
    </div>
</div>